<template>
    <div>
        <div class="row step">
            <div class="col-4 overflow-hidden position-relative">
                <div class="time d-flex align-items-center justify-content-md-end">
                    <div class="hour d-none d-lg-block">
                        <div class="white-pill bg-white my-1 rounded-10 border border-dark px-2 ml-2 d-flex align-items-center">
                            <svg-icon name="clock" width="15" color="black"/>
                            <span class="align-self-center ml-1">{{ step.departure_time }}</span>
                        </div>
                    </div>
                    <div class="circle-icon ml-2 cursor-pointer">
                        <svg-icon class="circle-icon-svg" :name="icon" height="2em" width="auto" :class="icon"/>
                    </div>
                </div>
                <div class="vertical-line position-absolute"></div>
            </div>
            <div class="col-8 pl-0">
                <div class="details">
                    <div class="hour col-4 pl-0 d-lg-none">
                        <div class="white-pill bg-white my-1 rounded-10 border border-dark px-2 ml-2 d-flex align-items-center">
                            <svg-icon name="clock" width="15" color="black"/>
                            <span class="align-self-center ml-1">{{ step.departure_time }}</span>
                        </div>
                    </div>
                    <div class="card mt-2">
                        <div class="card-body card-border">
                            <div v-if="step.transit" class="bus-name">
                                <strong><a href="javascript:void(0)" @click="openLink()">{{step.transit.agency.name}}</a></strong>
                            </div>
                            <h2 class="fw-normal mt-2">{{ step.description }}</h2>
                            <span>
                                {{ step.duration.text }} | {{ step.distance.text }}
                                <span v-if="showElevation(step.elevationHighest)"> | {{ step.elevationHighest }}
                                    <svg-icon name="chevron-up" width="auto" height="1em"></svg-icon>
                                </span>
                                <span v-if="showElevation(step.elevationLowest)"> {{ step.elevationLowest }}
                                    <svg-icon name="chevron-down" width="auto" height="1em"></svg-icon>
                                </span>
                            </span>
                        </div>
                        <div class=" col-12 card-footer text-muted border-0 text-left cursor-pointer step-footer"  @click="showDetails">
                            <span class=" text-left cost-colour">
                                <div class="col-md-6 col-sm-12 float-left">
                                    <h2>{{step.cost}}</h2>
                                </div>
                                <div v-if="showLink" :class="this.brand === 'kcc' ? 'float-right' : 'col-md-6 col-sm-12 float-right'">
                                    <span>
                                        <a href="javascript:void(0)" class="text-dark"><strong><u>Stage details</u></strong></a>
                                        <svg-icon class="ml-2 arrow-right" name="arrow-right" width="20"></svg-icon>
                                    </span>
                                </div>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="step.directions" class="row step">
            <div class="col-4 overflow-hidden position-relative">
                <div class="time d-flex align-items-center justify-content-md-end mt-5">
                    <div class="hour d-none d-lg-block">
                        <div class="white-pill instruction-pill-count bg-white my-1 rounded-10 border border-dark px-2 ml-2 d-flex align-items-center">
                            <span class="align-self-center ml-1">+{{ step.directions.length }}</span>
                        </div>
                    </div>
                    <div class="circle-icon ml-2 cursor-pointer bg-white">
                        <svg-icon name="three-dots" class="circle-icon-svg" height="auto" width="20"/>
                    </div>
                </div>
                <div class="vertical-line position-absolute"></div>
            </div>
            <div class="col-8 d-flex pl-0 mt-5" style="background-color: #EEEEEE; border-radius:10px" @click="showDirections">
                <div class="col-3 pl-0 d-lg-none" style="margin-top: 2px">
                    <div class="white-pill instruction-pill-count directions-length bg-white my-1 rounded-10 border border-dark px-2 ml-2 d-flex align-items-center">
                        <span class="align-self-center ml-1">{{ step.directions.length }}</span>
                    </div>
                </div>
                <div class="d-flex ml-2">
                    <button v-if="showingDirections"  type="button" class="btn-show">Hide instructions</button>
                    <button v-if="!showingDirections"  type="button" class="btn-show">Show instructions</button>
                </div>
            </div>
            <div class="col-4 overflow-hidden position-relative h-1">
                 <div class="vertical-line position-absolute"></div>
            </div>
        </div>
        <div class="wrapper" v-if="showingDirections">
            <direction-item v-for="(direction, index) in step.directions" :key="index" :html="direction.html_instructions" :distance="direction.distance.text" :icon="icon">
            </direction-item>
        </div>
    </div>
</template>
<script>
import DirectionItem from '@/components/DirectionItem.vue'

const whitelabel = require('../../whitelabel.config')[process.env.VUE_APP_BRAND]

export default {
    name: 'stage-item',
    props: ['step', 'icon', 'showLink', 'index'],
    components: {
        DirectionItem,
    },
    data() {
        return {
            showingDirections: false,
            brand: whitelabel.brand,
        }
    },
    methods: {
        showDetails() {
            this.$emit('showDetails')
        },
        showDirections() {
            if (!this.showingDirections) {
                this.showingDirections = true
            } else {
                this.showingDirections = false
            }
        },
        showElevation(elevation) {
            if (elevation === 'n/a' || elevation === null) {
                return false
            }
            return true
        },
        openLink() {
            window.open(this.step.transit.agency.url)
        },
    },
}
</script>
<style>
.card-border{
    border-bottom: 1px solid #E0E0E0
}
.instruction-pill-count{
    min-width:50px !important
}
.bus-name:hover{
    cursor: pointer
}

</style>
